import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { INTIMECommonModule } from '@shared/common/common.module';
import { UtilsModule } from '@shared/utils/utils.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { DrawerModule } from 'primeng/drawer';
import { ProfileIntegrationsComponent } from './profile-integrations.component';

@NgModule({
    declarations: [ProfileIntegrationsComponent],
    imports: [CommonModule, FormsModule, DrawerModule, NgSelectModule, UtilsModule, INTIMECommonModule],
    exports: [ProfileIntegrationsComponent],
})
export class ProfileIntegrationsModule {}
